import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { SplitVendasComponent } from './split-vendas.component';
import { AssociacoesComponent } from './associacoes/associacoes.component';

const routes: Routes = [{
  path: '',
  component: SplitVendasComponent,
  children: [
    {
      path: 'associacoes',
      component: AssociacoesComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['ASSOCIACOES']},

    },  

  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class SplitVendasRoutingModule { }

export const routedComponents = [
  SplitVendasComponent,  
  AssociacoesComponent,

];
